import { THEME_SPACINGS } from '../../shared/index.ts';
import { PREFIX } from '../../shared/utils/index.ts';

export function getSpace(spacing: keyof THEME_SPACINGS) {
  return `var(${PREFIX.SPACING}${spacing})`;
}
